import { Plugins } from "@capacitor/core";

// Services
import { StorageService } from "../services";

// Helpers
import { isNative, isMobileWeb, isAndroid } from "../helpers";

// Constants
import { APP_CONFIG } from "../constants";

const { Network, App } = Plugins;

export class NetworkGuard {

    setNetwork = () => {};

    constructor(setNetwork) {

        if ( isNative() || isMobileWeb() ) {

            this.setNetwork = setNetwork;
            this.refreshStatus();
        }
    }

    init() {

        if ( isNative() || isMobileWeb() ) {

            Network.addListener("networkStatusChange", status => {
    
                const prevStatusNetwork = StorageService.load(APP_CONFIG.STORAGE.KEYS.NETWORK);
                const isPageLogin = StorageService.load(APP_CONFIG.STORAGE.KEYS.PAGE_INIT) == null;

                this.refreshStatus();

                // Si es nativo, y el estado previo era desconectado y ahora se conectó, y estoy logueado se sale de la app
                if ( isNative() && prevStatusNetwork === false && status.connected &&
                !isPageLogin ) {
    
                    if ( isAndroid() ) {
                        
                        App.exitApp();
                    }
                }
            });        
        }
    }

    end() {

        Network.removeAllListeners();
    }

    async refreshStatus() {

        const status = await Network.getStatus();
        const network = {

            ...status
        };
        
        StorageService.save(APP_CONFIG.STORAGE.KEYS.NETWORK, network.connected);
        
        this.setNetwork(network);
    }
}